import { createFileRoute } from "@tanstack/react-router"
import { ClaudePage } from "@/components/pages/ClaudePage"
import { defaultMeta } from "@/lib/seo"

export const Route = createFileRoute(`/_public/claude`)({
  ssr: true,
  head: () =>
    defaultMeta({
      title: `MCP Connector for Claude Desktop & Claude Code`,
      description: `Add ChicTravel to Claude Desktop, claude.ai, or Claude Code over MCP and plan whole trips by chatting — itineraries, flights, hotels, and budgets, landing live in your real trip.`,
      path: `/claude`,
    }),
  component: ClaudePage,
})
